/**
 * A receipt's photo, big, without leaving the queue.
 *
 * Judging a receipt means reading the photo, and the list can only afford a
 * 72px thumbnail. Opening it used to mean a new browser tab per receipt —
 * twenty-seven tabs to open, read and close on a normal morning, and the queue
 * lost behind them every time. This shows the same presigned image over the
 * page: one click to open, Escape to close, and the row is still there with
 * its Approve on it.
 *
 * The new tab stays available for anybody who wants it — the same link, with
 * the same short-lived URL the caller has already refreshed.
 */
import React from 'react';
import { Modal } from 'react-bootstrap';
import { formatAmount } from '../../Utils/billingoDocuments';
import { RECEIPT_TYPE_LABELS } from './TripClaimRows';

function ReceiptPhotoModal({ url, expense, onClose }) {
  const type = RECEIPT_TYPE_LABELS[expense?.type] || expense?.type || 'Receipt';

  return (
    <Modal show onHide={onClose} size="lg" centered data-testid="receipt-photo-modal">
      <Modal.Header closeButton>
        <Modal.Title className="h6">
          {type}
          {' · '}
          {formatAmount(expense?.amount, expense?.currency)}
          {expense?.note ? ` · ${expense.note}` : ''}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center bg-light">
        <img
          src={url}
          alt="Receipt"
          data-testid="receipt-photo-full"
          style={{ maxWidth: '100%', maxHeight: '75vh', objectFit: 'contain' }}
        />
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <a href={url} target="_blank" rel="noreferrer" className="small">
          <i className="fa fa-up-right-from-square me-1" />
          Open in a new tab
        </a>
      </Modal.Footer>
    </Modal>
  );
}

export default ReceiptPhotoModal;
